(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('asyncPanelListView', asyncPanelListView);

    function asyncPanelListView() {
        return {
            restrict: 'E',
            controller: asyncPanelListViewCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                model: '=',
                options: '=',
                getModel: '=?',
                setValidationModel: '=?'
            },
            templateUrl: 'common/app/components/list-editable/index'
        };
    }

    function asyncPanelListViewCtrl(lodash, GenericModel, $scope, $element, DatasourceRegistry) {
        var vm = this;
        var dataSource = null;
        this.$onInit = function() {
            vm.no_records = false;

            // var kendoListDom = $element.find('.empty-list-wrapper');

            vm.getModel = getModel;
            vm.setValidationModel = setValidationModel;
            vm.dataItemAction = dataItemAction;
            vm.normalAction = normalAction;
            vm.showButton = showButton;
            vm.showSection = showButton;
            vm.refresh = refresh;
            // vm.getGaEvent = getGaEvent;

            dataSource = prepareDataSource();
            if (lodash.has(vm.options, 'list.identifier')) {
                DatasourceRegistry.add(vm.options.list.identifier, dataSource);

                $scope.$on('$destroy', function() {
                    DatasourceRegistry.remove(vm.options.list.identifier);
                });
            }

            vm.kendoOptions = angular.merge(
                {
                    dataSource: dataSource
                },
                lodash.get(vm.options,'list', {})
            );
        }

        function getModel() {
            return dataSource.data();
        }

        function setValidationModel(validationData) {
            dataSource.fetch(function() {
                var dataTemp = dataSource.data();
                dataTemp = dataTemp.map(function(d, i) {
                    const vdt = lodash.get(validationData, `[${i}]`, false);
                    const dt = Object.assign({}, d);
                    if (!vdt) {
                        delete dt.validation_rules;
                        return dt;
                    } else {
                        delete dt.validation_rules;
                        return angular.merge({}, dt, { validation_rules: vdt });
                    }
                });
                dataSource.data(dataTemp);
            });
        }

        function prepareDataSource() {
            if (lodash.has(vm.options, 'list.datasource')) {
                return new kendo.data.DataSource({
                    transport: {
                        read: readDataSource
                    },
                    change: function() {
                        if (lodash.has(vm.options, 'list.no_records')) {
                            vm.no_records = (this.view().length === 0);
                        }
                    }
                })
            } else {
                if (lodash.has(vm.options, 'list.data')) {
                    return new kendo.data.DataSource({
                        data: lodash.get(vm.options, 'list.data', [])
                    });
                } else {
                    return new kendo.data.DataSource({
                        data: vm.model || []
                    });
                }
            }
        }

        function readDataSource(readOptions) {
            const method = lodash.get(vm.options, 'list.datasource.method', 'query');
            const url = lodash.get(vm.options, 'list.datasource.url', '');
            const params = lodash.get(vm.options, 'list.datasource.params', {});
            const data = generateResourceOptions(readOptions.data, params, method);
            // prepare filter, and sort.
            var model = new GenericModel(url);
            model[method](data).$promise.then(function (res) {
                readOptions.success(res.rows);
            }, function (res) {
                readOptions.error(res);
            });
        }

        function generateResourceOptions(resourceData, myData, method) {
            var params = {};
            params = angular.merge(params, resourceData, myData);
            if (method == 'search') {
                params = {'data': params};
            }
            return params;
        }

        function dataItemAction(action, dataItem) {
            $scope.$emit(vm.options.dataitem_event_prefix+'.'+action, { model: dataItem });
            // if (action === 'preview') {
            //     $scope.listFilterService.showDetailView(dataItem);
            // } else {
            //     $scope.listFilterService.emitDataItemEvent(action, dataItem);
            // }
        }

        function showButton(type, dataItem) {
            const rules = lodash.get(vm.options, 'row_button_rules', {});
            if (!lodash.has(rules, type)) return true;
            const rule = rules[type];
            if (typeof rule === 'string') {
	            return lodash.get(dataItem, rules[type], false);
            }
            if (typeof rule === typeof {}) {
                const key = lodash.get(rule, 'key', '');
                const value = lodash.get(dataItem, key, false);
                if (lodash.has(rule, 'matches')) {
                    return value === rule.matches;
                }
                return !!value;
            }
            return true;
        }

        function refresh() {
            dataSource.read();
        }

        function normalAction(action) {
            $scope.$emit(vm.options.prefix+'.'+action, {});
        }
    }
})();